<template>
     <v-theme-provider dark>
          <base-section
               id="social"
               class="green lighten-2 text-center"
               space="56"
          >
               <base-icon class="mb-8"> mdi-instagram </base-icon>

               <base-section-heading
                    class="primary--text"
                    title="Instagram"
                    space="0"
               >
               </base-section-heading>

               <v-btn
                    class="font-weight-bold"
                    color="primary"
                    href="https://www.instagram.com/katinkstrinkets/"
                    light
                    min-width="168"
                    target="_blank"
                    x-large
               >
                    Follow Me

                    <v-icon right> mdi-open-in-new </v-icon>
               </v-btn>
          </base-section>
     </v-theme-provider>
</template>

<script>
export default {
     name: 'SectionNews',

     provide: {
          heading: { align: 'center' },
     },
}
</script>
